import { useParams } from 'react-router';
import { confirmEmail } from 'api-services/authentication';
import {useEffect } from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-v6';
import useLoading from 'hooks/use-loading';

const { Paragraph } = Typography;

const ConfirmEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const {setLoading} = useLoading();
  let planParam = '';

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    planParam = queryParams.get('plan');
    const confirmRegistration = async () => {
      try {
        setLoading(true);
        const response = await confirmEmail({
          hash: token,
          planId: planParam
        });

        if(response && response.data && response.data.url) {
          window.location.replace(response.data.url);
        } else {
          navigate('/login');
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    if(token)
      confirmRegistration();
  }, []);

  return (
    <div className='reset-verification'>
      <Paragraph>Please wait while verification is in progress.</Paragraph>
    </div>
  );
};

export default ConfirmEmail;
